module.exports = __webpack_public_path__ + "static/media/twitter.c5f6a56b.svg";